import { Component, Inject, OnInit } from '@angular/core';
import { InputComponent } from '../../../shared/components/input/input.component';
import { ModalComponent } from '../../../shared/components/modal/modal.component';
import { TegelModule } from '@scania/tegel-angular-17';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { SelectComponent } from '../../../shared/components/select/select.component';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Recebimento } from '../../../shared/models/recebimento';
import { DropDownOption } from '../../../shared/models/drop-down-option';
import { RecebimentoService } from '../../../shared/services/recebimento.service';
import { ToastService } from '../../../shared/services/toast.service';
import { ToastState as ts } from '../../../shared/enums/toast-state.enum';
import { DropDownHelper } from '../../../shared/helpers/dropdown.helper';
import { DateHelper } from '../../../shared/helpers/date.helper';
import { PhoneHelper } from '../../../shared/helpers/phone.helper';
import { CpfMaskDirective } from '../../../shared/directives/cpf-mask.directive';
import { CpfHelper } from '../../../shared/helpers/cpf.helper';

@Component({
  selector: 'app-dialog-recebimento-details',
  imports: [
    InputComponent,
    ModalComponent,
    TegelModule,
    ReactiveFormsModule,
    SelectComponent,
    CpfMaskDirective,
  ],
  templateUrl: './dialog-recebimento-details.component.html',
  styleUrl: './dialog-recebimento-details.component.scss',
})
export class DialogRecebimentoDetailsComponent implements OnInit {
  form: FormGroup;
  direcionamentoOptions: DropDownOption[] = [];

  constructor(
    private dialogRef: MatDialogRef<DialogRecebimentoDetailsComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      recebimento: Recebimento | null;
      localList: DropDownOption[];
      faseList: DropDownOption[];
    },
    private fb: FormBuilder,
    private recebimentoService: RecebimentoService,
    private toast: ToastService,
  ) {
    this.direcionamentoOptions = DropDownHelper.stringArrayToOptions([
      'Cabinas',
      'Chassis',
      'Expedição PBD',
      'KD',
      'Motores',
      'Protótipo',
      'Transmissão',
    ]);

    this.form = this.fb.group({
      id: [data?.recebimento?.id ?? 0],
      senha: [
        data?.recebimento?.senha ?? '',
        [Validators.required, Validators.maxLength(20)],
      ],
      driverId: [CpfHelper.format(data?.recebimento?.driverId ?? '')],
      celular: [data?.recebimento?.celular ?? ''],
      critico: [data?.recebimento?.critico ?? false],
      milkrun: [data?.recebimento?.milkrun ?? false],
      controlCenter: [data?.recebimento?.controlCenter ?? false],
      fornecedor: [data?.recebimento?.fornecedor ?? ''],
      notaFiscal: [data?.recebimento?.notaFiscal ?? ''],
      volume: [data?.recebimento?.volume ?? 0],
      quantidadeLinhas: [data?.recebimento?.quantidadeLinhas ?? 0],
      registro: [data?.recebimento?.registro ?? ''],
      observacao: [data?.recebimento?.observacao ?? ''],
      direcionamento: [data?.recebimento?.direcionamento ?? ''],
      responsavelInterno: [data?.recebimento?.responsavelInterno ?? ''],
      local: [data?.recebimento?.localId ?? null, [Validators.required]],
      fase: [data?.recebimento?.faseId ?? null, [Validators.required]],
      dataEntrada: [
        data.recebimento?.dataEntrada
          ? DateHelper.utcToLocalString(data.recebimento.dataEntrada)
          : '',
      ],
      dataSaida: [
        data.recebimento?.dataSaida
          ? DateHelper.utcToLocalString(data.recebimento.dataSaida)
          : '',
      ],
    });
  }

  ngOnInit(): void {
    const celularControl = this.form.get('celular');

    if (celularControl) {
      PhoneHelper.applyPhoneMaskOnInit(celularControl);
    }
  }

  onSave(formData: any) {
    const dto: Recebimento = {
      id: formData.id,
      dataEntrada: this.data.recebimento?.dataEntrada ?? DateHelper.nowUtc(),
      dataSaida: this.data.recebimento?.dataSaida ?? null,
      direcionamento: formData.direcionamento,
      senha: formData.senha,
      observacao: formData.observacao,
      responsavelInterno: formData.responsavelInterno,
      registro: formData.registro,
      fornecedor: formData.fornecedor,
      notaFiscal: formData.notaFiscal,
      driverId: CpfHelper.clean(formData.driverId),
      celular: formData.celular,
      controlCenter: formData.controlCenter,
      subidaDireta: formData.subidaDireta,
      volume: formData.volume,
      quantidadeLinhas: formData.quantidadeLinhas,
      critico: formData.critico,
      milkrun: formData.milkrun,
      localId: formData.local,
      faseId: formData.fase,
    };
    this.update(dto);
  }

  private update(data: Recebimento) {
    this.recebimentoService.update(data).subscribe({
      next: (result) => {
        if (result.success) {
          this.toast.showToast(ts.success, 'Recebimento atualizado');
          this.dialogRef.close(result.content);
        } else {
          this.toast.showToast(ts.error, result.messages[0]);
        }
      },
      error: (e) => {
        this.toast.showToast(ts.error, e.error[0]);
        this.dialogRef.close();
      },
    });
  }
}
